import { render, staticRenderFns } from "./contact-log.vue?vue&type=template&id=5be6fdea&"
import script from "./contact-log.vue?vue&type=script&lang=js&"
export * from "./contact-log.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports